import _                                         from 'underscore';
import React, { FC }                             from 'react';
import classNames                                from 'classnames';
import { StyledContainer, StyledContainerProps } from './StyledContainer';
import { ClassValue }                            from 'classnames/types';

export enum LayoutNames {
	FOCUSED_CENTERED = 'focused-centered'
}

export type LayoutNameType = LayoutNames | string;

export interface LayoutProps extends StyledContainerProps {
	name?: LayoutNameType | LayoutNameType[],
	fadeIn?: boolean,
	className?: ClassValue,
	
	[ additionalProps: string ]: any,
}

const defaultProps: LayoutProps = {
	name:      null,
	fadeIn:    false,
	className: null,
}

const Layout: FC<LayoutProps> = ( props ) => {
	
	let {
		    children,
		    className,
		    name,
		    fadeIn,
		    ...p
	    } = props;
	
	let layoutNames = _.isArray( name ) ? name.map( ( n: any ) => `layout--${ n }` ) : `layout--${ name }`
	
	let containerClasses = classNames( {
			'fade-in': fadeIn,
			'layout':  true,
		},
		layoutNames,
		className,
	);
	
	let styleContainerProps: StyledContainerProps = p;
	
	return (
		<StyledContainer className={ containerClasses } { ...styleContainerProps }>
			
			{ children }
		
		</StyledContainer>
	);
};

Layout.defaultProps = defaultProps;

export { Layout }
